import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-aboutus.component',
  imports: [RouterLink],
  templateUrl: './aboutus.component.html',
})
export class AboutusComponent {

}
